//@flow
import {
  Validator
} from 'lib/idd-auth';

const {
  Network
} = require('relay-runtime');

// Define a function that fetches the results of an operation (query/mutation/etc)
// and returns its results as a Promise:
function fetchQuery(
  operation,
  variables,
  cacheConfig,
  uploadables,
) {
  let token = Validator.getToken();
  if (!token) token = "";
  const protocol = process.env.USE_SSL === 'yes' ? 'https://' : 'http://';
  const host = process.env.GRAPHQL_HOST ? process.env.GRAPHQL_HOST : "";
  const port = process.env.GRAPHQL_PORT ? process.env.GRAPHQL_PORT : 4000;
  const url = process.env.DEV_MODE === 'true' ? protocol + host + ":" + port : protocol + host
  // return fetch(protocol + host + ":" + port, {

  // console.log("TOKEN:",token)
  const gqlraw = JSON.stringify({
    query: operation.text, // GraphQL text from input
    variables,
  });
  // console.log(gqlraw);
  return fetch(url, {
    method: 'POST',
    headers: {
      // Add authentication and other headers here
      'content-type': 'application/json',
      'Authorization': `Bearer ${token}`,
      // 'X-api-key': "0kmNYhxHPP9YCscUNiuGv53oyoOlfDPmaYjL1BfI"
    },
    body: gqlraw,
  }).then(response => {
    return response.json();
  });
}

// Create a network layer from the fetch function
const network = Network.create(fetchQuery);

export default network;